import React, { useEffect, useState, useRef, useImperativeHandle } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, IconButton } from '@material-ui/core';
import VisibilityIcon from '@material-ui/icons/Visibility';
import PublishIcon from '@material-ui/icons/Publish';
import './upload.files.form.contact.scss';
import DeleteIcon from '@material-ui/icons/Delete';
import { IDocument as DocumentDTO, IContact, IContactInfo } from 'app/modules/contact/model/contact.model';
import InsertDriveFileOutlinedIcon from '@material-ui/icons/InsertDriveFileOutlined';
import TransitionsModal from 'app/shared/components/common/modal/modal';
import ModalWithAction from 'app/shared/components/common/modal/modal-with-Action';
import { IRootState } from 'app/shared/reducers';
import { getModalInformationButton } from 'app/modules/cms/service/store/selectors';

export interface IUploadFilesFormContact {
  createContactAndUploadDocs: any;
  documentsList: any;
  uploadCms?: any;
  uploadErrorsCms?: any;
}
const UploadFilesFormContact = ({ createContactAndUploadDocs, documentsList, uploadCms, uploadErrorsCms }: IUploadFilesFormContact) => {
  const MAX_FILE_SIZE = 5242880; // 5M
  const MOTIF_ADHESION = 'SUBSCRIPTION';
  const FILE_EXTENSIONS = [
    'application/pdf',
    'image/png',
    'image/jpeg',
    'image/gif',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  ];
  const modalInformation: any = useSelector(getModalInformationButton)

  const [formData, setFormData] = useState<IContact>({});
  const [height, setHeight] = useState(0);
  const refHeight = useRef(null);
  const [documents, setDocuments] = useState<DocumentDTO[]>([]);
  const [fileSizeError, setFileSizeError] = useState(false);
  const [fileExtensionError, setFileExtensionError] = useState(false);
  const [errorMessage, setErrorMessage] = useState(false);
  const [textBody, setTextBody] = useState('');

  const handleChange = e => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };



  const handleFileChange = e => {
    const files = e.target.files;
    if (files && files[0]) {
      const file = files[0];

      if (FILE_EXTENSIONS.includes(file.type) && file.size <= MAX_FILE_SIZE && documents.length < 3) {
        const reader = new FileReader();
        reader.readAsBinaryString(file);
        reader.onload = function () {
          const data64 = btoa(reader.result.toString());
          const newFile: DocumentDTO = {};
          newFile.name = file.name;
          newFile.type = file.type;
          newFile.size = file.size;
          newFile.data = data64;
          newFile.refDataTypeCode = 1;
          newFile.createTask = false;
          newFile.username = 'user';
          newFile.subscriptionNumber = '002222';
          newFile.claimNumber = '';
          setDocuments([...documents, newFile]);
          documentsList([...documents, newFile]);
        };
      } else if (file.size > MAX_FILE_SIZE) {
        setTextBody(uploadErrorsCms?.modal_erreur_document_file_size);
        setErrorMessage(true);
      }

      else if (documents.length === 3) {
        setTextBody(uploadErrorsCms?.modal_erreur_max_upload_documents_label);
        setErrorMessage(true);
      }
      else {

        setTextBody(uploadErrorsCms?.modal_ereur_document_formats);
        setErrorMessage(true);
      }
      e.target.value = null;
    }
  };

  useEffect(() => {
    setHeight(refHeight?.current?.clientHeight);
    setFileSizeError(documents.filter(document => document.size > MAX_FILE_SIZE)?.length > 0);
    setFileExtensionError(documents.filter(document => !FILE_EXTENSIONS.includes(document.type))?.length > 0);
  }, [documents]);

  useEffect(() => {
    if (height !== refHeight?.current) setHeight(refHeight?.current?.clientHeight);
  }, [height]);

  const openFile = (document: DocumentDTO) => {
    const windowObject = window.open('location=no,enableviewportscale=yes');
    if (document.type === FILE_EXTENSIONS[0] || document.type === FILE_EXTENSIONS[4]) {
      windowObject.document.write(
        "<iframe frameborder='0' width='100%' scrolling='no' style='margin: -10px;overflow:hidden;' height='100%' src='data:" +
        document.type +
        ';base64,' +
        document.data +
        "'></iframe>"
      );
    } else {
      windowObject.document.write("<img width='100%' src='data:" + document.type + ';base64,' + document.data + "'/>");
    }
    windowObject.document.title = document.name;
  };

  const removeFile = documentIndex => {
    setDocuments(documents.filter((document, index) => index !== documentIndex));
    documentsList(documents.filter((document, index) => index !== documentIndex));
  };

  const formatCorrection = base64 => {
    if (base64[base64.length - 1] === '=') formatCorrection(base64.slice(0, -1));
    else return base64;
  };

  return (
    <>

      <form className="comp-upload" autoComplete="off" onSubmit={e => createContactAndUploadDocs()}>
        <div className="icon-upload">
          <input id="import-file-input" type="file" onChange={e => handleFileChange(e)} hidden />
          <label htmlFor="import-file-input">
            <div>
              <img className='upload-icon' src={uploadCms?.upload_icon} />
            </div>
            <div className="textDecoration">Joindre un {documents.length ? ' autre' : ''} fichier</div>
          </label>
        </div>
        <div className="information">
          <div className="">{uploadCms?.upload_information_formats}</div>
          <div className="">{uploadCms?.upload_information_taille}</div>
        </div>
        {fileSizeError && (
          <div className="row">
            <div className="col-12 file-error-msg">
              <img src={'/content/images/mobile-view/icon-material-error.svg'} />
              <div className="text">{uploadCms?.modal_ereur_document_formats}</div>
            </div>
          </div>
        )}
        {fileExtensionError && (
          <div className="row">
            <div className="col-12 file-error-msg">
              <img src={'/content/images/mobile-view/icon-material-error.svg'} />
              <div className="text">{uploadCms?.upload_information_formats}</div>
            </div>
          </div>
        )}

        <div className="file-uploaded-list">
          {documents.map((document, index) => {
            return (
              <div key={index} className="row m-0 fileRow m-2">
                <div className="col-9 file-name">
                  {document.size <= MAX_FILE_SIZE && FILE_EXTENSIONS.includes(document.type) ? (
                    <>
                      <img className='upload-icon' src={uploadCms?.file?.file_icon} />
                      <div className="text">{document.name}</div>
                    </>
                  ) : (
                    <>
                      <img className='upload-icon' src={uploadCms?.file?.file_icon} />
                      <div className="text text-with-error">{document.name}</div>
                    </>
                  )}
                </div>
                <div className="col-3 action-button">
                  {document.size <= MAX_FILE_SIZE && FILE_EXTENSIONS.includes(document.type) && (
                    <IconButton className="btn-show" aria-label="Afficher" onClick={() => openFile(document)}>
                      <img className='upload-icon' src={uploadCms?.file?.eye_icon} />
                    </IconButton>
                  )}
                  <IconButton className="btn-delete mr-1" aria-label="Supprimer" onClick={() => removeFile(index)}>
                    <img className='upload-icon' src={uploadCms?.file?.delete_icon} />
                  </IconButton>
                </div>
              </div>
            );
          })}
        </div>
        {errorMessage && <ModalWithAction  icon={modalInformation?.erreur_Icon.url}  showModal={true} setShowModel={setErrorMessage} textBody={textBody} btnCloseLabel={modalInformation?.UNDERSTAND_button} />}
      </form>
    </>
  );
};

export default UploadFilesFormContact;
